import React, { createContext, ReactNode, useEffect, useState } from "react";

type AlertData = {
    title?: string;
    message: string;
};

type ErrorAlertContextType = {
    showAlert?: boolean;
    alertData?: AlertData;
    onShowAlert?: (data: string | AlertData) => void;
    onClose?: () => void;
};

export const ErrorAlertContext = createContext<
    ErrorAlertContextType | undefined
>(undefined);

const ErrorAlertContextProvider = ({ children }: { children: ReactNode }) => {
    const [showAlert, setShowAlert] = useState(false);
    const [alertData, setAlertData] = useState<AlertData>({ message: "" });

    useEffect(() => {
        if (showAlert) {
            const timer = setTimeout(() => {
                setShowAlert(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [showAlert]);

    const onShowAlert = (data: string | AlertData) => {
        setShowAlert(true);

        if (typeof data === 'string') {
            setAlertData({ message: data });
        } else {
            console
            setAlertData(data);
        }
    };

    const onClose = () => {
        setShowAlert(false);
    };

    return (
        <ErrorAlertContext.Provider
            value={{
                showAlert,
                alertData,
                onShowAlert,
                onClose,
            }}
        >
            {children}
        </ErrorAlertContext.Provider>
    );
};

export default ErrorAlertContextProvider;